import { columns } from "../../../../dtos/columns";
import Conversiones from "../../../../utils/conversiones";
import { EnumTipoEstadoRegistro, EstadoRegistro } from "../../../../utils/enums";
import { getDescriptionEstadoSubsidioMINVU } from "../../../contabilidad/validadorAsientos/utils/utils";
import AccionesList from "../components/accionesList";
import { ListaMINVU } from "../components/modalListadoMinvu";


export function useColumns(renderizar: () => void, tipoArchivo: string) {

    const COLUMNS: columns<ListaMINVU>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            cell: (row) =>
                <AccionesList
                    data={row}
                    renderizar={renderizar}
                    tipoArchivo={tipoArchivo}
                />
            ,
            sortable: false,
            sortField: 'descripcionEstado',
            wrap: true,
            export: true,
        },
        {
            name: 'ID archivo',
            selector: (row) =>
                row.idArchivo,
            sortable: true,
            sortField: 'idArchivo',
            wrap: true,
            export: true
        },
        {
            name: 'Tipo beneficio',
            selector: (row) => row.descripcionTipoBeneficio,
            sortable: true,
            sortField: 'descripcionTipoBeneficio',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Estado',
            selector: (row) =>
                getDescriptionEstadoSubsidioMINVU(row.estado),
            sortable: true,
            sortField: 'estado',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Fecha generación',
            selector: (row) =>
                Conversiones.fechaCortaFormat(row.fechaGeneracion.toString() ?? ''),
            sortable: true,
            sortField: 'fechaGeneracion',
            wrap: true,
            export: true,
        },
        {
            name: 'Fecha envío',
            selector: (row) =>
                Conversiones.fechaCortaFormat(row.fechaEnvio?.toString() ?? ''),
            sortable: true,
            sortField: 'fechaEnvio',
            wrap: true,
            export: true,
        },
        {
            name: 'Nombre archivo',
            selector: (row) =>
                row.nombreArchivo,
            sortable: true,
            sortField: 'nombreArchivo',
            wrap: true,
            export: true,
        },
    ]

    return { COLUMNS };
}